<template>
  <div class="hc-hexaline">
    <svg :style="style" class="hc-hexaline-chart" >
      <hexa-line
        :data="data"
        :offset="offset"
        :color="color"
        :offColor="offColor"
        :width="width * .76"
        :height="height * .55"
        :scale="scale"
        :animation="animation"
        :animationDuration="animationDuration"
        :animationOptions="animationOptions"
        :unit="unit"
      ></hexa-line>
    </svg>
  </div>
</template>

<script>
import HexaLine from '../shapes/HexaLine'
export default {
  name: 'HexaLinechart',
  components: {
    HexaLine
  },
  props: {
    data: {
      type: Array,
      default () { return [] }
    },
    color: {
      type: String,
      default: '#f56043'
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    },
    unit: {
      type: String,
      default: '%'
    }
  },
  data () {
    return {
      width: 800,
      height: 460
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth || 660
      this.height = this.$el.offsetHeight || 380
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    offset () {
      return {top: .15 * this.height, left: .12 * this.width, bottom: .3 * this.height, right: .12 * this.width}
    },
    scale () {
      return Math.sqrt(this.width / 800 * this.height / 460)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>
</style>
